import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AnalysisActionButtons({
  onSave,
  onReset,
  hasAnalysis,
  isViewingSavedAnalysis = false,
  darkMode = false,
  isAnalysisRunning = false,
  onActionComplete,
  onNewAnalysis,
}) {
  const navigate = useNavigate();
  
  // Determine save button state and text
  const canSave = hasAnalysis && !isViewingSavedAnalysis;
  
  const getSaveButtonText = () => {
    if (isViewingSavedAnalysis) return "Saved Analysis";
    return "Save Analysis";
  };

  const getSaveButtonTitle = () => {
    if (isViewingSavedAnalysis) return "Currently viewing a saved analysis";
    return "";
  };

  const handleSaveClick = () => {
    if (canSave && onSave) {
      onSave(); // This will now trigger the modal
    }
  };

  const handleNewAnalysisClick = () => {
    if (!isAnalysisRunning && onNewAnalysis) {
      onNewAnalysis();
    }
  };

  const handleUseFormClick = () => {
    if (!isAnalysisRunning) {
      navigate('/new');
      if (onActionComplete) {
        onActionComplete();
      }
    }
  };

  return (
    <div className="p-6 border-b border-gray-200 dark:border-gray-700">
      <div className="space-y-3">
        <button
          onClick={handleNewAnalysisClick}
          disabled={isAnalysisRunning}
          className={`w-full px-4 py-2 rounded font-medium transition-colors ${
            isAnalysisRunning
              ? darkMode 
                ? 'bg-gray-600 text-gray-400 cursor-not-allowed' 
                :  'bg-gray-300 text-gray-500 cursor-not-allowed'
              : darkMode 
                ? 'bg-green-600 hover:bg-green-700 text-white' 
                : 'bg-green-600 hover:bg-green-700 text-white'
          }`}
          title={isAnalysisRunning ? "Analysis in progress..." : "Start a new analysis"}
        >
          {isAnalysisRunning ? 'Analysis Running...' : '+ New Analysis'}
        </button>
        
        {/* Link to full form */}
        {!isAnalysisRunning && (
          <div className="text-center">
            <button
              onClick={handleUseFormClick}
              className={`text-xs underline transition-colors ${
                darkMode 
                  ? 'text-gray-400 hover:text-gray-300' 
                  : 'text-gray-500 hover:text-gray-700'
              }`}
              title="Use the full analysis form instead of the sidebar"
            >
              use the form instead
            </button>
          </div>
        )}
      </div>
    </div>
  );
} 